<template>
  <div class="mineWrap fontw500">
    <div class="topWrap">
      <div class="topBox zzcontent r jc ac">
        <div class="topImgBox">
          <img :src="userInfo.portrait" alt="" />
        </div>
        <div class="topBoxR r jsb ac">
          <div class="topBoxRL c jc as">
            <div class="topBoxRLTitleBox r js ac">
              <p class="topBoxRLTitle">{{ userInfo.nickName }}</p>
              <img
                v-if="userInfo.isVip"
                class="topBoxRLImg"
                src="../../../static/mine/teacherIcon.png"
                alt=""
              />
            </div>
            <p class="topBoxRLText">账号：{{ userInfo.userName }}</p>
            <div class="topBoxRLTextBox r js ac">
              <p class="topBoxRLText" v-if="userInfo.isVip">
                会员有效期至：{{ userInfo.vipEndTimeStr }}
              </p>
              <p class="topBoxRLText" v-else>开通指正会员，海量好课免费看</p>

              <div
                class="topBoxRLBtn gray"
                v-if="userInfo.isVip"
                @click="$router.push('/member')"
              >
                续费
              </div>
              <div class="topBoxRLBtn" v-else @click="$router.push('/member')">
                开通
              </div>
            </div>
          </div>
          <div class="topBoxRR r je ac">
            <div class="topBoxRRL">
              <p class="topBoxRRLTitle">{{ userInfo.bonusMoney }}</p>
              <p class="topBoxRRLText">我的奖学金</p>
            </div>
            <div class="topBoxRRBtn" @click="showToast = true">获取</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainWrap zzcontent r jsb cs">
      <div class="mainL">
        <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/classList"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon1"></div>
          <div class="mainLText">我的课程</div>
        </router-link>
        <!-- <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/workList"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon2"></div>
          <div class="mainLText">我的作品</div>
        </router-link>
        <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/dynamicList"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon3"></div>
          <div class="mainLText">我的动态</div>
        </router-link> -->
        <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/scholarship"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon4"></div>
          <div class="mainLText">奖学金</div>
        </router-link>
        <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/orderList"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon5"></div>
          <div class="mainLText">我的订单</div>
        </router-link>
        <router-link
          tag="div"
          class="mainLItem r js ac"
          to="/mine/personal"
          active-class="mainItemAc"
          exact-active-class="mainItemAc"
          :replace="true"
        >
          <div class="mainLIcon mainLIcon6"></div>
          <div class="mainLText">个人设置</div>
        </router-link>
      </div>

      <div class="mainR">
        <router-view></router-view>
      </div>
    </div>

    <scholarshipToast
      :show="showToast"
      @closeFun="showToast = false"
    ></scholarshipToast>
  </div>
</template>
<script>
import scholarshipToast from "./components/scholarshipToast.vue";
export default {
  components: {
    scholarshipToast,
  },
  data() {
    return {
      // 个人信息
      userInfo: {},

      // 显示奖学金规则弹框
      showToast: false,
    };
  },
  computed: {
    changeName: function () {
      return this.$store.state.changeName;
    },
  },
  watch: {
    changeName(n, o) {
      if (n) {
        this.getUserInfo();
        this.$store.commit("CHANGENAME", 0);
      }
    },
  },
  mounted() {
    this.getUserInfo();
    console.log(this.$store);
  },
  methods: {
    // 获取个人信息
    getUserInfo() {
      this.$api.getUserInfo().then((res) => {
        if (res.success) {
          this.userInfo = res.data;
          console.log(res);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mineWrap {
  background-color: #f5f5f5;
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 42px;
  // 顶部
  .topWrap {
    background-color: #000;
    width: 100%;
    margin-bottom: 42px;
    .topBox {
      height: 200px;
      margin: 0 auto;
      .topImgBox {
        background-color: #b7cdf0;
        width: 141px;
        height: 141px;
        border: 3px solid #ffffff;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 39px;
      }

      .topBoxR {
        width: calc(100% - 287px);
        .topBoxRLTitleBox {
          margin-bottom: 20px;
          .topBoxRLTitle {
            font-size: 24px;
            color: #ffffff;
            margin-right: 21px;
          }
          .topBoxRLImg {
            width: 32px;
            height: 28px;
          }
        }

        .topBoxRLText {
          font-size: 20px;
          color: rgba(#fff, 0.7);
          margin-right: 29px;
        }
        .topBoxRLTextBox {
          margin-top: 10px;
        }
        .topBoxRLBtn {
          width: 70px;
          height: 32px;
          background: #ffffff;
          border-radius: 19px;
          overflow: hidden;
          font-size: 16px;
          color: #333333;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
          &.gray {
            background-color: rgba(#ffffff, 0.54);
            color: #fff;
          }
        }

        .topBoxRR {
          color: #fff;
          max-width: calc(100% - 450rpx);
          .topBoxRRL {
            margin-right: 32px;
          }
          .topBoxRRLTitle {
            font-size: 38px;
            line-height: 53px;
            margin-bottom: 6px;
          }
          .topBoxRRBtn {
            width: 90px;
            height: 46px;
            background: #f8fafc;
            border-radius: 4px;
            font-size: 20px;
            line-height: 46px;
            text-align: center;
            color: #333;
            cursor: pointer;
          }
        }
      }
    }
  }

  .mainWrap {
    margin: 0 auto;
    .mainL {
      width: 194px;
      .mainLItem {
        background: #ffffff;
        padding-left: 28px;
        height: 74px;
        border-bottom: 1px solid rgba(#979797, 0.1);
        font-size: 18px;
        line-height: 25px;
        color: #999999;
        cursor: pointer;
        position: relative;
        &:first-child {
          border-radius: 10px 10px 0 0;
        }
        &:last-child {
          border: none;
          border-radius: 0 0 10px 10px;
        }
        &.mainItemAc {
          color: #333;
          &::after {
            position: absolute;
            top: 50%;
            right: -20px;
            transform: translateY(-50%);
            content: "";
            color: transparent;
            border-width: 10px;
            border-style: solid;
            border-left-color: #fff;
          }
          .mainLIcon1 {
            background-image: url("../../../static/mine/mineIcon11.png");
          }
          .mainLIcon2 {
            background-image: url("../../../static/mine/mineIcon21.png");
          }
          .mainLIcon3 {
            background-image: url("../../../static/mine/mineIcon31.png");
          }
          .mainLIcon4 {
            background-image: url("../../../static/mine/mineIcon41.png");
          }
          .mainLIcon5 {
            background-image: url("../../../static/mine/mineIcon51.png");
          }
          .mainLIcon6 {
            background-image: url("../../../static/mine/mineIcon61.png");
          }
        }
        .mainLIcon {
          background-position: center;
          background-size: 20px 20px;
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          margin-right: 11px;
        }
        .mainLIcon1 {
          background-image: url("../../../static/mine/mineIcon10.png");
        }
        .mainLIcon2 {
          background-image: url("../../../static/mine/mineIcon20.png");
        }
        .mainLIcon3 {
          background-image: url("../../../static/mine/mineIcon30.png");
        }
        .mainLIcon4 {
          background-image: url("../../../static/mine/mineIcon40.png");
        }
        .mainLIcon5 {
          background-image: url("../../../static/mine/mineIcon50.png");
        }
        .mainLIcon6 {
          background-image: url("../../../static/mine/mineIcon60.png");
        }
      }
    }

    .mainR {
      background: #ffffff;
      width: 970px;
      min-height: 628px;
      border-radius: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/mine/index.vue